import {useSubtitle} from '../../../../../../common/helpers/react/hooks/useSubtitle';
import {tAsString} from '../../../../../../common/helpers/react/text/tAsString';
import AssigneesTable from '../../assignees/AssigneesTable';
import AssigneesSearch from '../../assignees/AssigneesSearch';
import {useState} from 'react';
import LockAgentsToolbar from './LockAgentsToolbar';
import {useNavigate} from 'react-router-dom';

export default function LockAgentsPresenter() {
    useSubtitle(tAsString('MANAGE_LOCK'));

    const [checkedRows, setCheckedRows] = useState<string[]>([]);
    const navigate = useNavigate();

    const leaveLockMode = () => {
        setCheckedRows([]);
        navigate('/agents', {state: { keepSearch: true}});
    };

    return (
        <>
            <h1>{tAsString('MANAGE_AGENTS')}</h1>
            <AssigneesSearch
                persistSearchValue={true}
                onSearch={leaveLockMode}
            />
            <LockAgentsToolbar
                checkedRows={checkedRows}
                setCheckedRows={setCheckedRows}
                onNavigate={leaveLockMode}
            />
            <AssigneesTable
                checkedRows={checkedRows}
                setCheckedRows={setCheckedRows}
            />
        </>
    );
}
